<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="has_perm('create_advertise') || GET_ACCOUNT_DATA.id == 1"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              {{ $t("advertise.title") }}
            </div>
          </div>
          <div class="box-body flex_body">
            <div>
              <div
                class="form-group"
                style="display: flex; justify-content: space-between"
              >
                <label for="name" class="col-sm-2" style="align-self: center">
                  {{ $t("advertise.name") }}
                </label>
                <div class="col-sm-8">
                  <b-form-input
                    v-model="advertise.name"
                    type="text"
                    required
                    class="form-control"
                    id="name"
                  />
                </div>
              </div>
            </div>
            <div>
              <ul class="nav nav-tabs">
                <li class="active">
                  <a data-toggle="tab" href="#ad_content">
                    {{ $t("advertise.content") }}
                  </a>
                </li>
                <li>
                  <a data-toggle="tab" href="#ad_install">
                    {{ $t("advertise.install") }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="tab-content">
              <div id="ad_content" class="tab-pane fade in active">
                <trumbowyg
                  v-model="advertise.content"
                  class="form-control"
                  name="content"
                ></trumbowyg>
                <button
                  style="border:none; background-color: white;outline-style: none;"
                  @click="clickInputImage"
                >
                  <i
                    style="font-size: 15pt;color: saddlebrown;"
                    class="fa fa-picture-o"
                    aria-hidden="true"
                  ></i>
                </button>
                <span>{{ $t("common.insert_image") }}</span>
              </div>

              <div id="ad_install" class="tab-pane">
                <div class="flex_column">
                  <!-- active -->
                  <div class="form-group" style="margin-top: 2rem">
                    <label for="active" class="col-sm-2 control-label">
                      {{ $t("advertise.active") }}
                    </label>
                    <div>
                      <div>
                        <input
                          style="margin-left: 11rem"
                          type="checkbox"
                          v-model="advertise.active"
                          id="checkbox"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- end active -->
                  <!-- date install -->
                  <div style="display:flex">
                    <label for="active" class="col-sm-2 control-label">
                      {{ $t("advertise.time") }}
                    </label>
                    <div>
                      <div>
                        <div
                          class="form-group"
                          style="display: flex; justify-content: space-between"
                        >
                          <label for="date_from">
                            {{ $t("advertise.date_from") }}
                          </label>
                          <div class="col-sm-8">
                            <date-picker
                              v-model="advertise.date_from"
                              :config="options"
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <div
                          class="form-group"
                          style="display: flex; justify-content: space-between"
                        >
                          <label for="date_to">
                            {{ $t("advertise.date_to") }}
                          </label>
                          <div class="col-sm-8">
                            <date-picker
                              v-model="advertise.date_to"
                              :config="options"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end wrap dateinstall -->
                </div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <button
              type="button"
              class="btn btn-labeled btn-danger"
              @click="doCancel"
              style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
            >
              <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
              {{ $t("common.back") }}
            </button>

            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              style="margin-right: 5px;"
              @click="onSave"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-ok"></i>
              </span>
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </row>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!-- input image  -->
    <input
      type="file"
      style="display: none;"
      ref="ImageInput"
      :accept="mimes"
      @change="onHandleImage"
      @click="$refs.ImageInput.value = null"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";

import loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
// Import this component
import Trumbowyg from "vue-trumbowyg";
// Import editor css
import "trumbowyg/dist/ui/trumbowyg.css";

export default {
  name: "AdvertiseAdd",
  props: {
    mimes: {
      type: String,
      default: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"
    }
  },
  data() {
    return {
      advertise: {
        name: "",
        content: "",
        active: false,
        date_from: null,
        date_to: null
      },
      isLoading: false,
      options: {
        format: "DD-MM-YYYY"
      },
      paste_image: null
    };
  },
  watch: {
    GET_ADVERTISE_DETAIL_LIST: function() {
      this.advertise.name = this.GET_ADVERTISE_DETAIL_LIST.name;
      this.advertise.content = this.GET_ADVERTISE_DETAIL_LIST.content;
      this.advertise.active = this.GET_ADVERTISE_DETAIL_LIST.active;
      this.advertise.date_from = this.GET_ADVERTISE_DETAIL_LIST.date_from;
      this.advertise.date_to = this.GET_ADVERTISE_DETAIL_LIST.date_to;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ADVERTISE_DETAIL_LIST",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "ADD_ADVERTISE",
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "UPDATE_ADVERTISE",
      "GET_ADVERTISE_DETAIL"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    doCancel() {
      this.$router.push({
        name: "AdvertiseList"
      });
    },
    onSave: function() {
      let id = parseInt(this.$route.params.id);
      let data = {
        name: this.advertise.name,
        content: this.advertise.content,
        active: this.advertise.active,
        date_from: utils.formatSqlDate(this.advertise.date_from, "DD-MM-YYYY", "YYYY-MM-DD"),
        date_to: utils.formatSqlDate(this.advertise.date_to, "DD-MM-YYYY", "YYYY-MM-DD")
      };
      this.isLoading = true;
      if (id != 0) {
        this.UPDATE_ADVERTISE({ id: id, ...data })
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "AdvertiseList"
              });
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
              this.isLoading = false;
            }.bind(this)
          );
      } else {
        this.ADD_ADVERTISE(data)
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({
                name: "AdvertiseList"
              });
              this.isLoading = false;
            }.bind(this)
          )
          .catch(
            function() {
              this.ERROR_TOAST();
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    clickInputImage: function() {
      this.$refs.ImageInput.click();
    },
    onHandleImage: async function() {
      let img = this.$refs.ImageInput.files[0];
      if (img.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("ProjectGeneralSettings.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.paste_image = await uploadFileToMediaAgent(img, "documents/")
        if (this.paste_image != null) {
          document.execCommand(
            "insertHTML",
            false,
            `<img style="width:150px" src='${this.paste_image}'> `
          );
          this.advertise.content += `<img style="width:150px" src='${this.paste_image}'>`;
          this.SUCCESS_TOAST();
        }
      }
    }
  },
  mounted() {
    let id = parseInt(this.$route.params.id);
    if (id != 0) {
      this.GET_ADVERTISE_DETAIL({ id: id });
    }
  },
  components: {
    Trumbowyg,
    "date-picker": datePicker,
    loading: loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style>
.flex_body {
  display: flex;
  flex-direction: column;
  min-height: 50vh;
}

.flex_between {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/Advertise/AdvertiseAdd.vue